<template>
  <div class="mine page">
    <div class="wrapper">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <!-- Top gradient header -->
        <div style="width: 100%; height: 13.3333rem; background: linear-gradient(90deg, rgba(223, 53, 173, 0.8), rgba(79, 29, 181, 0.8));">
          <div class="header">
            <van-nav-bar class="nav-bar">
              <template #right>
                <div style="padding: 10px 0px 0px;" @click="$router.push({path:'/ServiceOnline'});">
                  <img src="/img/home/xx.png" style="height: 30px;" />
                </div>
              </template>
            </van-nav-bar>
            <!-- User info row -->
            <div style="width: 100%; padding: 0px 6%; display: flex; justify-content: flex-start; align-items: center; margin-top: 1.33333rem;" @click="doLogin()">
              <div style="border: 4px solid rgb(255, 255, 255); width: 60px; height: 60px; border-radius: 30px; position: relative; display: inline-block; flex-shrink: 0;">
                <img :src="userInfo.header_img || '/img/footer/18.png'" style="object-fit: cover; width: 58px; height: 58px; border-radius: 29px;" />
              </div>
              <div style="display: flex; flex-direction: column; justify-content: center; align-items: flex-start; padding-left: 1.33333rem; flex: 1 1 0%; font-size: 12px;">
                <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-direction: column; width: 100%; height: 60px;">
                  <div style="width: 100%; height: 24px; font-size: 13px; line-height: 24px; text-align: left; color: rgb(255, 255, 255);">
                    {{ userInfo.username || $t('setting.log_reg') }}
                    <span v-if="userInfo.vip_level" style="align-items: center; font-weight: 600; padding: 2px 4px; border-radius: 0.13333rem; font-size: 13px; margin-left: 0.33333rem; background: linear-gradient(rgb(255, 172, 56), rgb(255, 218, 5));">
                      {{ userInfo.vip_level }}
                    </span>
                  </div>
                  <div style="width: 100%; height: 24px; font-size: 13px; line-height: 24px; text-align: left; color: rgb(255, 255, 255);">
                    {{ $t('my.creditScore') }}: {{ userInfo.credit_score || 0 }}
                  </div>
                </div>
              </div>
              <i class="van-icon van-icon-arrow" style="color: #fff;"></i>
            </div>
          </div>
        </div>

        <!-- Balance card + buttons -->
        <div style="width: 94%; margin: -4.33333rem auto 0px; position: relative; z-index: 10;">
          <!-- Balance card -->
          <div style="width: 92%; margin: 0px auto 2%; background-image: url('/img/yue.png'); height: 6rem; justify-content: space-between; padding: 4% 3%; background-size: 100% 100%; border-radius: 3.2vw; display: flex; align-items: center; color: rgb(255, 255, 255);">
            <div>
              <div style="margin-bottom: 10%;">{{ $t('my.balance') }}</div>
              <div style="font-weight: bold;">{{ userInfo.money || 0 }}</div>
            </div>
            <div style="display: flex; align-items: center;">
              <span class="font-28 font-gray" style="display: flex; align-items: center; color: white; font-size: 24px;">{{ $t('reservation.unit') }}</span>
              <img src="/img/shua.png" class="van-icon__image" style="width: 24px; height: 24px; margin-left: 10px;" @click="refresh()" />
            </div>
          </div>
          <!-- Two buttons -->
          <div style="display: flex; width: 94%; margin: 10px auto; justify-content: space-between;">
            <div @click="doWithdrawal()" style="background-image: url('/img/1.png'); width: 49%; background-size: 100% 100%; border-radius: 3.2vw; height: 3.5rem; display: flex; justify-content: center; align-items: center; background-repeat: no-repeat; color: rgb(255, 255, 255);">
              {{ $t('my.exchange') }}
            </div>
            <div @click="doRecharge()" style="background-image: url('/img/yue.png'); width: 49%; height: 3.5rem; justify-content: center; background-repeat: no-repeat; background-size: 100% 100%; border-radius: 3.2vw; display: flex; align-items: center; color: rgb(255, 255, 255);">
              {{ $t('my.recharge') }}
            </div>
          </div>
        </div>

        <!-- Menu list -->
        <div style="width: 100%; border-top: 0.6rem solid rgb(246, 248, 250); margin-bottom: 50px;">
          <div style="width: 100%; background: rgb(255, 255, 255); display: flex; justify-content: center; padding: 0px; align-items: center; flex-wrap: wrap; border-radius: 0.33333rem; margin-top: 0px;">
            <!-- Basic Information -->
            <div style="width: 100%; display: flex; justify-content: flex-start; align-items: center; padding: 0.66667rem 0px 1rem 6%; position: relative; height: 70px;" @click="$router.push({path:'/Infomation'});">
              <img src="/img/home/jb.png" style="display: block; width: 38px; height: 38px; object-fit: contain;" />
              <p style="color: rgb(67, 39, 136); padding: 0.53333rem 6px; font-size: 16px; margin: 0;">{{ $t('my.basic_information') }}</p>
              <i class="van-icon van-icon-arrow" style="position: absolute; right: 20px; color: #ccc;"></i>
            </div>
            <!-- Bank Card Info -->
            <div style="width: 100%; display: flex; justify-content: flex-start; align-items: center; padding: 0.66667rem 0px 1rem 6%; position: relative; height: 70px;" @click="doWithdrawal()">
              <img src="/img/home/czjf.png" style="display: block; width: 38px; height: 24px; object-fit: contain;" />
              <p style="color: rgb(67, 39, 136); padding: 0.53333rem 6px; font-size: 16px; margin: 0;">{{ $t('setting.bind_bank_info') }}</p>
              <i class="van-icon van-icon-arrow" style="position: absolute; right: 20px; color: #ccc;"></i>
            </div>
            <!-- Cryptocurrency wallet -->
            <div style="width: 100%; display: flex; justify-content: flex-start; align-items: center; padding: 0.66667rem 0px 1rem 6%; position: relative; height: 70px;" @click="toService()">
              <img src="/img/home/qianbao.png" style="display: block; width: 38px; height: 38px; object-fit: contain;" />
              <p style="color: rgb(67, 39, 136); padding: 0.53333rem 6px; font-size: 16px; margin: 0;">{{ $t('my.crypto_wallet') }}</p>
              <i class="van-icon van-icon-arrow" style="position: absolute; right: 20px; color: #ccc;"></i>
            </div>
            <!-- Exchange Record -->
            <div style="width: 100%; display: flex; justify-content: flex-start; align-items: center; padding: 0.66667rem 0px 1rem 6%; position: relative; height: 70px;" @click="$router.push({path:'/WithdrawRecord'});">
              <img src="/img/home/txjl.png" style="display: block; width: 38px; height: 38px; object-fit: contain;" />
              <p style="color: rgb(67, 39, 136); padding: 0.53333rem 6px; font-size: 16px; margin: 0;">{{ $t('my.exchange_record') }}</p>
              <i class="van-icon van-icon-arrow" style="position: absolute; right: 20px; color: #ccc;"></i>
            </div>
            <!-- Data Records -->
            <div style="width: 100%; display: flex; justify-content: flex-start; align-items: center; padding: 0.66667rem 0px 1rem 6%; position: relative; height: 70px;" @click="$router.push({path:'/GameRecord'});">
              <img src="/img/home/rw.png" style="display: block; width: 38px; height: 38px; object-fit: contain;" />
              <p style="color: rgb(67, 39, 136); padding: 0.53333rem 6px; font-size: 16px; margin: 0;">{{ $t('my.data_records') }}</p>
              <i class="van-icon van-icon-arrow" style="position: absolute; right: 20px; color: #ccc;"></i>
            </div>
            <!-- Information Notice -->
            <div style="width: 100%; display: flex; justify-content: flex-start; align-items: center; padding: 0.66667rem 0px 1rem 6%; position: relative; height: 70px;" @click="toNotice()">
              <img src="/img/home/gg.png" style="display: block; width: 38px; height: 38px; object-fit: contain;" />
              <p style="color: rgb(67, 39, 136); padding: 0.53333rem 6px; font-size: 16px; margin: 0;">{{ $t('my.sys_notice') }}</p>
              <i class="van-icon van-icon-arrow" style="position: absolute; right: 20px; color: #ccc;"></i>
            </div>
            <!-- Modify Login Password -->
            <div style="width: 100%; display: flex; justify-content: flex-start; align-items: center; padding: 0.66667rem 0px 1rem 6%; position: relative; height: 70px;" @click="$router.push({path:'/SetLoginPassword'});">
              <img src="/img/home/dl.png" style="display: block; width: 38px; height: 38px; object-fit: contain;" />
              <p style="color: rgb(67, 39, 136); padding: 0.53333rem 6px; font-size: 16px; margin: 0;">{{ $t('my.Login_password') }}</p>
              <i class="van-icon van-icon-arrow" style="position: absolute; right: 20px; color: #ccc;"></i>
            </div>
            <!-- Set Finance Password -->
            <div style="width: 100%; display: flex; justify-content: flex-start; align-items: center; padding: 0.66667rem 0px 1rem 6%; position: relative; height: 70px;" @click="$router.push({path:'/SetPayPassword'});">
              <img src="/img/home/dl.png" style="display: block; width: 38px; height: 38px; object-fit: contain;" />
              <p style="color: rgb(67, 39, 136); padding: 0.53333rem 6px; font-size: 16px; margin: 0;">{{ $t('my.set_finance_password') }}</p>
              <i class="van-icon van-icon-arrow" style="position: absolute; right: 20px; color: #ccc;"></i>
            </div>
            <!-- Language Selection -->
            <div style="width: 100%; display: flex; justify-content: flex-start; align-items: center; padding: 0.66667rem 0px 1rem 6%; position: relative; height: 70px;" @click="$router.push({path:'/Language'});">
              <img src="/img/home/dl.png" style="display: block; width: 38px; height: 38px; object-fit: contain;" />
              <p style="color: rgb(67, 39, 136); padding: 0.53333rem 6px; font-size: 16px; margin: 0;">{{ $t('setting.language') }}</p>
              <i class="van-icon van-icon-arrow" style="position: absolute; right: 20px; color: #ccc;"></i>
            </div>
            <!-- Logout -->
            <div
              style="display: inline-block; margin: 1.66667rem auto 3.33333rem; text-align: center; width: 80%; background: linear-gradient(90deg, rgba(223, 53, 173, 0.8), rgba(79, 29, 181, 0.8)); color: rgb(255, 255, 255); padding: 0.86667rem 0px; border-radius: 0.33333rem; font-size: 0.93333rem; cursor: pointer;"
              @click="loginout()"
            >
              {{ $t('setting.logout') }}
            </div>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {},
      isLoading: false,
    };
  },
  methods: {
    refresh() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          this.getUserInfo();
          this.$toast(this.$t('reservation.refresh'));
        } else {
          this.$router.push({ path: '/Login' });
        }
      }, 500);
    },
    toNotice() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/Notice' });
      } else {
        this.$router.push({ path: '/Login' });
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          this.getUserInfo();
          this.$toast(this.$t('reservation.refresh'));
        } else {
          this.$router.push({ path: '/Login' });
        }
      }, 500);
    },
    doLogin() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/Infomation' });
      } else {
        this.$router.push({ path: '/Login' });
      }
    },
    doWithdrawal() {
      this.$http({
        method: 'get',
        url: 'user_get_bank',
      }).then(res => {
        if (res.data.is_bank) {
          this.$router.push('withdraw');
        } else {
          this.$router.push('BindCard');
        }
      });
    },
    doRecharge() {
      this.$router.push('ServiceOnline');
    },
    toService() {
      const service = this.$store.getters.getBaseInfo;
      if (service && service.iskefu == 1) {
        window.location.href = service.kefu;
      } else {
        this.$toast.fail(this.$t('setting.forbid'));
      }
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info',
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t('video.account_out'));
            localStorage.clear();
            this.$router.push({ path: '/Login' });
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    loginout() {
      localStorage.clear();
      this.$router.push({ path: '/Login' });
    },
  },
  created() {
    if (localStorage.getItem('token')) {
      this.getUserInfo();
    } else {
      this.userInfo.username = this.$t('setting.log_reg');
      this.userInfo.header_img = '/img/footer/my.png';
    }
  },
};
</script>

<style scoped>
.page {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #f6f8fa;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.mine .wrapper {
  position: relative;
  width: 100%;
  min-height: 100vh;
}
.nav-bar {
  background: transparent !important;
}
::v-deep .van-nav-bar__content {
  background: transparent !important;
}
::v-deep .van-nav-bar__title {
  color: #fff;
}
.header {
  padding-bottom: 0;
}
.language {
  top: 10px;
  height: 30px;
}
.language img {
  height: 100%;
}
.menu-row {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0.66667rem 0px 1rem 6%;
  position: relative;
  height: 70px;
}
.menu-icon {
  display: block;
  width: 38px;
  height: 38px;
  object-fit: contain;
}
.menu-label {
  color: rgb(67, 39, 136);
  padding: 0.53333rem 6px;
  font-size: 16px;
  margin: 0;
}
.menu-arrow {
  position: absolute;
  right: 20px;
  color: #ccc;
}
::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #ffffff;
  font-size: 14px;
}
</style>
